import script from "./Root.vue?vue&type=script&setup=true&lang=ts"
export * from "./Root.vue?vue&type=script&setup=true&lang=ts"

import "./Root.vue?vue&type=style&index=0&id=dc5083ea&lang=scss&scoped=true"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc5083ea"]])

export default __exports__